<script>
  import ReboquistaService from '../../../../domain/reboquista/services/reboquista'
  // eslint-disable-next-line no-duplicate-imports
  import {sugerirCodigoReboquista} from '../../../../domain/reboquista/services/reboquista'
  import { isArray, debounce } from 'lodash'
  import {VueMaskDirective as mask} from 'v-mask'

  export default {
    components: {},
    nome: 'atendente-reboquista-form',
    directives: {mask},
    props: {
      user: {
        required: true,
        type: Object
      },
      reboquistaId: {
        type: Number
      }
    },
    data () {
      return {
        isLoading: false,
        isLoaded: false,
        cadastroError: null,
        atualizadoSucesso: null,
        extraModel: {
          validadeCnh: null
        },
        data: {
          id: null,
          nome: null,
          rg: null,
          cnh: null,
          validadeCnh: null,
          codigo: null,
          ativo: 1,
          sequencialGrv: 1,
          usuario: null,
          atendente: true
        },
        idReboquista: null,
        codigoReboquista: {
          numero: null,
          existe: null
        }
      }
    },
    computed: {
    },
    created () {
      this.idReboquista = this.user.reboquista
      this.data.usuario = this.user.id
    },
    mounted () {
      this.data.nome = this.user.pessoa.nome
      this.start()
    },
    activated () {
    },
    destroyed () {
    },
    watch: {},
    methods: {
      start () {
        if (this.idReboquista) {
          this.$loaderOverlay.open().message('Carregando')
          ReboquistaService.find(this.idReboquista)
            .then((response) => {
              this.isLoaded = true
              this.$loaderOverlay.hide()
              this.data = response.data
              if (this.data.usuario) {
                this.data.usuario = this.data.usuario.id
              }
              console.log(response)
            })
            .catch((response) => {
              this.$loaderOverlay.hide()
              console.log(response)
            })
        } else {
          this.isLoaded = true
          // this.$loaderOverlay.open().message('Aguarde')
        }
      },
      submit () {
        this.cadastroError = null
        this.atualizadoSucesso = false
        this.$loaderOverlay.open().message('Processando...')
        this.$bar.start()
        window.setTimeout(() => {
          this.$loaderOverlay.message('Aguarde...')
        }, 1000)
        ReboquistaService.cadastrar(this.data, this.idReboquista).then((response) => {
          let callbackEnd = () => {
            this.$bar.finish()
            this.$loaderOverlay.hide()
            this.$emit('finishSubmit', response.data.id)
            if (this.idReboquista) {
              // Continua na mesma tela de edição
              // this.$nextTick(() => {
              this.start()
              this.atualizadoSucesso = true
              this.$el.querySelector('#sucessMsg').focus()
              // })
            } else {
              // Redirecionr para tela de visualização
              // this.$router.push({name: 'documento.editar', params: {id: response.data.id}})
              this.atualizadoSucesso = true
            }
          }
          callbackEnd()
        }).catch((response) => {
          this.$bar.finish()
          this.$loaderOverlay.hide()
          this.cadastroError = response.data.errors
          this.$nextTick(() => {
            this.$refs.error.focus()
          })
          console.log(response)
        })
      },
      printError (err) {
        if (isArray(err)) {
          return err[0]
        }
        return err
      },
      checarNumeroGrv: debounce(function () {
        const numero = this.data.codigo
        if (numero === null || !numero.toString().trim().length) {
          this.codigoReboquista.existe = null
          return
        }
        this.codigoReboquista.existe = -1 // loading
        ReboquistaService.checarExistenciaCodigoReboquista(numero)
          .then(response => {
            this.codigoReboquista.existe = response.data.existe
          })
          .catch(error => {
            console.log(error)
            if (error.status === 404) {
              this.codigoReboquista.existe = false
            } else {
              this.codigoReboquista.existe = null
              alert('Ocorreu um erro ao checar a GRV')
            }
          })
      }, 300),
      sugerirCodigoReboquista () {
        sugerirCodigoReboquista()
        .then(response => {
          let {codigo} = response.data
          this.data.codigo = String(codigo).padStart(3, '0')
        })
        .catch(error => {
          console.log(error)
        })
      }
    }
  }
</script>

<template>
  <transition name="slide">
    <div v-if="isLoaded" class="content-transition">
      <div class="bg-light lter b-b wrapper-md">
        <div class="row">
          <div class="col-sm-6"><h1 class="m-n font-thin h3">Cadastro de Código/Sequencial</h1></div>
          <div class="col-sm-6"></div>
        </div>
      </div>
      <div class="wrapper-md">
        <div class="panel panel-default">
          <div class="panel-body">
            <div tabindex="-1" ref="error" v-if="cadastroError !== null" class="alert alert-danger">
              <div class="m-b-sm font-bold">Erro ao registrar, corrija e tente novamente</div>
              <p v-for="(erro, key) in cadastroError">{{printError(erro)}}</p>
            </div>
            <a name="sucessMsg" id="sucessMsg" href="javascript:void(0)" ref="sucessMsg"></a>
            <div tabindex="-1" ref="error" v-if="atualizadoSucesso !== null && atualizadoSucesso" class="alert alert-success">
              <div class="font-bold">{{$route.params.id && 'Atualizado' || 'Cadastrado'}} com sucesso!</div>
            </div>
            <form @submit.prevent.stop="" class="bs-example form-horizontal">

              <div class="form-group">
                <label class="col-sm-4 control-label">Código</label>
                <div class="col-sm-6">
                  <input type="text" v-model="data.codigo" class="form-control" @keyup="checarNumeroGrv"/>
                  <span class="text-danger text-center" v-if="codigoReboquista.existe === true">
                    <i class="fa fa-times text-danger m-l-sm"></i> Código já cadastrado para outro reboquista
                  </span>
                  <span class="text-success text-center" v-if="codigoReboquista.existe === false">
                    <i class="fa fa-check text-success m-l-sm" ></i> Código disponível
                  </span>
                  <i class="fa fa-spinner fa-spin m-l-sm" v-if="codigoReboquista.existe === -1"></i>
                </div>
                <div class="col-sm-2">
                  <button class="btn btn-sm btn-default" @click="sugerirCodigoReboquista">Sugerir código</button>
                </div>
              </div>

              <div class="form-group">
                <label class="col-sm-4 control-label">Sequencial</label>
                <div class="col-sm-8">
                  <input type="text" class="form-control" v-model="data.sequencialGrv"/>
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-4 control-label">Ativo</label>
                <div class="col-sm-8">
                  <input type="checkbox" v-model="data.ativo">
                </div>
              </div>

              <div class="clearfix"></div>

              <hr>
              <div class="row wrapper">
                <u-button @click="submit" class="btn m-b-xs w-xs btn-info m-r-xs" :disabled="codigoReboquista.existe === true || codigoReboquista.existe === -1">
                  <span v-if="!data.id">Cadastrar</span>
                  <span v-if="data.id">Atualizar</span>
                </u-button>
                <!--<u-button class="btn m-b-xs w-xs m-r-xs btn-default" @click="$router.push({name: 'config.reboquista.list'})">Cancelar</u-button>-->
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>



// WEBPACK FOOTER //
// AtendenteReboquistaForm.vue?f290503e